export default __webpack_public_path__ + "static/voxel-knight-aa164f1af9857fe8204c4241d2337121.png";